import { Injectable, inject } from '@angular/core';
import { HisAuthService } from '../../../auth/service/his-auth.service';
import { HisSessionStorageKeys } from '../../model/his-session-storage-keys';

/**
 * Service to access the HTML5 SessionStorage.
 * This storage has a separate "session cache" for each tab.
 */
@Injectable({providedIn: 'root'})
export class HisSessionStorageService {
    private auth = inject(HisAuthService);


    public clearOnUserChange( auth: HisAuthService ) {
        let lastUsernameKey = HisSessionStorageKeys.CS_SYS_LAST_USERNAME;
        let lastUsername = sessionStorage.getItem( lastUsernameKey );
        // username is the unique login name and allows us to recognize a login/logout
        console.log( 'username =', auth.username, ', lastUsername =', lastUsername );
        if ( this.auth.username !== lastUsername ) {
            // delete Angular keys
            this.clearAngularSessionStorageKeys();
            // update account info
            sessionStorage.setItem( lastUsernameKey, auth.username );
        }
    }

    /**
     * Store a value in the HTML5 SessionStorage.
     *
     * This method should only be used for simple variables or small data structures. It makes particularly sense
     * for variables that might get lost on redirects (e.g. refresh of browser content).
     *
     * @param key Should start with prefix 'his_' and the segment, e.g. 'his_cs_sys_'
     * @param value the value to store, or null
     */
    public put( key: HisSessionStorageKeys, value: any ) {
        if ( value ) {
            sessionStorage.setItem( key, JSON.stringify( value ) );
        } else {
            sessionStorage.removeItem( key );
        }
    }

    /**
     * Retrieve a value from the HTML5 SessionStorage.
     *
     * @param key the lookup key
     * @return the value or null
     */
    public get( key: HisSessionStorageKeys ): any | null {
        return JSON.parse( sessionStorage.getItem( key ) );
    }

    /**
     * Clear all Angular keys except his_cs_sys_lastUsername, but not the JSF keys.
     * XXX It might be useful to delete some JSF keys, too, but we do not have enough information about that.
     */
    public clearAngularSessionStorageKeys() {
        sessionStorage.removeItem( HisSessionStorageKeys.CS_SYS_LAST_MENU_ITEM );
        sessionStorage.removeItem( HisSessionStorageKeys.CS_SYS_LAST_SEARCH_URL );
        sessionStorage.removeItem( HisSessionStorageKeys.CS_SYS_LAST_SEARCHRESULT_URL );
        sessionStorage.removeItem( HisSessionStorageKeys.CS_SYS_SEARCH_CRITERIA_SET_COMPONENT_ID );
        sessionStorage.removeItem( HisSessionStorageKeys.CS_SYS_LAST_SEARCH_BUTTON );
        sessionStorage.removeItem( HisSessionStorageKeys.CS_SYS_LAST_SEARCH_CRITERIA_SET );
        sessionStorage.removeItem( HisSessionStorageKeys.CS_SYS_LAST_BACK_URL );
    }

    public removeSearchKeys() {
        sessionStorage.removeItem( HisSessionStorageKeys.CS_SYS_LAST_SEARCH_URL );
        sessionStorage.removeItem( HisSessionStorageKeys.CS_SYS_LAST_SEARCHRESULT_URL );
    }

    public removeLastBackUrlKey() {
        sessionStorage.removeItem(HisSessionStorageKeys.CS_SYS_LAST_BACK_URL);
    }
}
